import type {OptimizedSchedule} from '@domain/schedule'
import {OptimizerStatus} from '@domain/schedule'
import {useLayoutEffect} from 'react'

import {useSelectedOptimizerPlan} from '../../../providers/SelectedOptimizerPlanProvider'
import {OptimizerScheduleType} from '../../../types'

import {OptimizerSchedule} from './useOptimizerPlansOverview'

export const useSelectLatestSuccessPlanOnMount = (optimizerSchedules: OptimizerSchedule[]) => {
  const {setSelectedInTableScheduleId, setVisibleScheduleId} = useSelectedOptimizerPlan()

  useLayoutEffect(() => {
    const latestSuccessfulPlan = [...optimizerSchedules]
      .reverse()
      .find(
        (schedule) =>
          schedule.type === OptimizerScheduleType.Optimized &&
          schedule.optimizationDetails.optimizerStatus === OptimizerStatus.Success
      ) as OptimizedSchedule | undefined

    setSelectedInTableScheduleId(latestSuccessfulPlan?.scheduleId)
    setVisibleScheduleId(latestSuccessfulPlan?.scheduleId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
